import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { useSnackbar } from "notistack";

import { excluir } from "../../../../services/formulario/FormularioService";

import globalUseStyles from "../../../../styles";
import useStyles from "./styles";

const ExcluirFormulario = (props) => {
  const { open, onClose, formulario, afterSubmit } = props;

  const globalClasses = globalUseStyles();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const { id, nomeFormulario, existeReuniaoVinculada } = formulario;

  const handleExcluir = async (id) => {
    try {
      await excluir(id).then((response) => {
        console.log(response);
        if (response && (response.status === 200 || response.status === 204)) {
          enqueueSnackbar("Formulário excluído com sucesso", {
            variant: "success",
          });
        } else {
          enqueueSnackbar(
            "Ocorreu algum Erro ao excluir - tente novamente mais tarde",
            { variant: "error" }
          );
        }
      });
    } catch (e) {
      enqueueSnackbar("Ocorreu Erro ao excluir - tente novamente mais tarde", {
        variant: "error",
      });
      console.log("---- error");
      console.log(e);
    }

    afterSubmit();
    onClose();
  };

  return (
    <div>
      <Dialog fullWidth open={open} onClose={onClose}>
        <DialogTitle>
          <Typography paragraph className={globalClasses.tituloDialog}>
            Excluir Formulário
          </Typography>
          <IconButton
            className={globalClasses.closeButtonDialog}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {existeReuniaoVinculada ? (
            <>
              <Typography paragraph>
                Não é possível excluir o formulário, pois o mesmo já está
                vinculado a uma reunião
              </Typography>
              <Typography className={classes.nomeDoFormulario}>
                Nome do formulário: {nomeFormulario}
              </Typography>
            </>
          ) : (
            <>
              <Typography paragraph>
                Tem certeza que deseja excluir esse formulário?
                <br />
                Essa ação não pode ser desfeita.
              </Typography>
              <Typography className={classes.nomeDoFormulario}>
                {nomeFormulario}
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={onClose}>
            Cancelar
          </Button>
          {!existeReuniaoVinculada && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleExcluir(id)}
            >
              Excluir Formulário
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ExcluirFormulario;
